"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var community = _interopRequireWildcard(require("@/api/community"));
var _permission = require("@/utils/permission");
var _filters = require("@/filters");
var _public = require("@/libs/public");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'communityTopic',
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          if (this.scrollHeight - this.scrollTop < this.clientHeight + 1) {
            binding.value();
          }
        }, {
          passive: true
        });
      }
    }
  },
  data: function data() {
    return {
      currentTab: 0,
      tabActive: '',
      star: 0,
      visible: false,
      direction: 'rtl',
      // 是否展开，默认全部折叠
      isExpandAll: false,
      multiple: false,
      moren: '',
      isChecked: false,
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      search: {
        limit: 10,
        page: 1,
        name: ''
      },
      tableFrom: {
        page: 1,
        limit: 20,
        auditStatus: 0,
        type: '',
        title: '',
        authorName: '',
        categoryId: '',
        topicId: '',
        searchType: 'all'
      },
      title: '',
      statusList: [{
        label: '待审核',
        value: 0
      }, {
        label: '已通过',
        value: 1
      }, {
        label: '已拒绝',
        value: 2
      }, {
        label: '平台关闭',
        value: 3
      }],
      headeNum: [{
        title: '待审核',
        type: '0'
      }, {
        title: '全部',
        type: '10'
      } //全部无值，此处为了做选中样式，赋值10，10代表全部状态
      ],
      cateSelect: [],
      topicSelect: [],
      dialogVisible: false,
      loading: false,
      loadingAudit: false,
      isExamine: false,
      // 是否是审核
      community_id: '',
      rules: {
        status: [{
          required: true,
          message: '请选择审核状态',
          trigger: 'change'
        }],
        refusal: [{
          required: true,
          message: '请填写拒绝原因',
          trigger: 'blur'
        }]
      },
      //强制下架
      ruleForm: {
        id: 0,
        reason: ''
      },
      //评论列表分页
      tableFromReply: {
        page: 1,
        limit: 20,
        nid: 0
      },
      //评论列表数据
      replyData: {
        data: [],
        total: 0
      },
      id: 0,
      formValidate: {},
      //详情
      //审核
      auditStatusFrom: {
        auditStatus: 0,
        id: 0,
        refusalReason: ''
      },
      loadingBtn: false,
      multipleSelectionAll: [],
      multipleSelection: [],
      idKey: 'id',
      visibleCategory: false,
      //分类弹窗
      categoryId: '',
      //分类
      noteIdList: [] //笔记列表id
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:community:note:page:list'])) this.getList(1);
    this.getCateSelect();
    this.getTopicSelect();
  },
  methods: {
    filterEmpty: _filters.filterEmpty,
    checkPermi: _permission.checkPermi,
    //审核拒绝
    cancelForm: function cancelForm() {
      var _this = this;
      this.$modalPrompt('textarea', '拒绝原因').then(function (V) {
        _this.auditStatusFrom.refusalReason = V;
        _this.onAuditSubmit();
      });
    },
    // 审核点击
    onAuditStatus: function onAuditStatus(type) {
      var _this2 = this;
      this.auditStatusFrom.auditStatus = type;
      if (type === 1) {
        this.$modalSure('审核通过该内容吗？').then(function () {
          _this2.onAuditSubmit();
        });
      } else {
        this.cancelForm();
      }
    },
    //审核提交
    onAuditSubmit: function onAuditSubmit() {
      var _this3 = this;
      this.auditStatusFrom.id = this.community_id;
      community.communityNoteAuditApi(this.auditStatusFrom).then(function (res) {
        _this3.$message.success('操作成功');
        _this3.dialogVisible = false;
        _this3.loadingBtn = false;
        _this3.getList();
      }).catch(function (res) {
        _this3.loadingBtn = false;
      });
    },
    //编辑星级
    submitForm: function submitForm() {
      var _this4 = this;
      community.communityStarUpdateApi({
        id: this.id,
        star: this.star
      }).then(function (res) {
        _this4.$message.success('编辑成功');
        _this4.visible = false;
        _this4.getList();
      });
    },
    handleClick: function handleClick(tab) {
      this.tabActive = tab.name;
      if (this.tabActive === '10') {
        this.tableFrom.auditStatus = '';
      } else {
        this.tableFrom.auditStatus = 0;
      }
      this.getList(1);
    },
    onClose: function onClose() {
      this.dialogVisible = false;
    },
    // 评论列表；
    getReplyNoteList: function getReplyNoteList(id) {
      var _this5 = this;
      this.tableFromReply.nid = id;
      community.communityReplyNoteListApi(this.tableFromReply).then(function (res) {
        _this5.replyData.total = res.total;
        _this5.replyData.data = res.list;
      });
    },
    pageChangeReply: function pageChangeReply(page) {
      this.tableFromReply.page = page;
      this.getReplyNoteList(this.community_id);
    },
    handleSizeChangeReply: function handleSizeChangeReply(val) {
      this.tableFromReply.limit = val;
      this.getReplyNoteList(this.community_id);
    },
    //评论删除
    handleReplyDelete: function handleReplyDelete(id) {
      var _this6 = this;
      this.$modalSure('删除该评论').then(function () {
        community.communityReplyDelApi(id).then(function () {
          _this6.$message.success('删除成功');
          _this6.getReplyNoteList(_this6.community_id);
        });
      });
    },
    // 分类列表；
    getCateSelect: function getCateSelect() {
      var _this7 = this;
      community.communityCategoryListApi({
        limit: 100,
        page: 1
      }).then(function (res) {
        _this7.cateSelect = res.list;
      });
    },
    // 下拉加载更多
    selectLoadMore: function selectLoadMore() {
      this.search.page = this.search.page + 1;
      if (this.search.page > this.totalPage) return;
      this.getTopicSelect(); // 请求接口
    },
    // 远程搜索
    remoteMethod: function remoteMethod(query) {
      var _this8 = this;
      this.loading = true;
      this.search.name = query;
      this.search.page = 1;
      this.topicSelect = [];
      setTimeout(function () {
        _this8.loading = false;
        _this8.getTopicSelect(); // 请求接口
      }, 200);
    },
    // 话题列表；
    getTopicSelect: function getTopicSelect() {
      var _this9 = this;
      community.communityTopicListApi(this.search).then(function (res) {
        _this9.totalPage = res.totalPage;
        _this9.total = res.total;
        _this9.topicSelect = _this9.topicSelect.concat(res.list);
      });
    },
    //批量移动
    categoryBatch: function categoryBatch() {
      if (this.noteIdList.length === 0) return this.$message.warning('请至少选择一个内容');
      this.visibleCategory = true;
    },
    //批量移动提交
    submitFormCategory: function submitFormCategory() {
      var _this0 = this;
      if (this.categoryId === 0) return this.$message.warning('请选择要移动到的分类');
      community.communitycCategoryBatchApi({
        categoryId: this.categoryId,
        noteIdList: this.noteIdList
      }).then(function (res) {
        _this0.$message.success('移动成功');
        _this0.visibleCategory = false;
        _this0.getList();
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this1 = this;
      this.multipleSelection = val;
      setTimeout(function () {
        _this1.changePageCoreRecordData();
        var data = [];
        if (_this1.multipleSelectionAll.length) {
          _this1.multipleSelectionAll.map(function (item) {
            data.push(item.id);
          });
        }
        _this1.noteIdList = data;
      }, 50);
    },
    // 设置选中的方法
    setSelectRow: function setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      var idKey = this.idKey;
      var selectAllIds = [];
      this.multipleSelectionAll.forEach(function (row) {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.table.clearSelection();
      for (var i = 0; i < this.tableData.data.length; i++) {
        if (selectAllIds.indexOf(this.tableData.data[i][idKey]) >= 0) {
          // 设置选中，记住table组件需要使用ref="table"
          this.$refs.table.toggleRowSelection(this.tableData.data[i], true);
        }
      }
    },
    // 记忆选择核心方法
    changePageCoreRecordData: function changePageCoreRecordData() {
      // 标识当前行的唯一键的名称
      var idKey = this.idKey;
      var that = this;
      // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
      if (this.multipleSelectionAll.length <= 0) {
        this.multipleSelectionAll = this.multipleSelection;
        return;
      }
      // 总选择里面的key集合
      var selectAllIds = [];
      this.multipleSelectionAll.forEach(function (row) {
        selectAllIds.push(row[idKey]);
      });
      var selectIds = [];
      // 获取当前页选中的id
      this.multipleSelection.forEach(function (row) {
        selectIds.push(row[idKey]);
        // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
        if (selectAllIds.indexOf(row[idKey]) < 0) {
          that.multipleSelectionAll.push(row);
        }
      });
      var noSelectIds = [];
      // 得到当前页没有选中的id
      this.tableData.data.forEach(function (row) {
        if (selectIds.indexOf(row[idKey]) < 0) {
          noSelectIds.push(row[idKey]);
        }
      });
      noSelectIds.forEach(function (id) {
        if (selectAllIds.indexOf(id) >= 0) {
          for (var i = 0; i < that.multipleSelectionAll.length; i++) {
            if (that.multipleSelectionAll[i][idKey] == id) {
              // 如果总选择中有未被选中的，那么就删除这条
              that.multipleSelectionAll.splice(i, 1);
              break;
            }
          }
        }
      });
    },
    // 列表
    getList: function getList(num) {
      var _this10 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.title = encodeURIComponent(this.title);
      community.communityNoteListApi(this.tableFrom).then(function (res) {
        _this10.tableData.data = res.list;
        _this10.tableData.total = res.total;
        _this10.$nextTick(function () {
          this.setSelectRow(); //调用跨页选中方法
        });
        _this10.listLoading = false;
      }).catch(function (res) {
        _this10.listLoading = false;
      });
    },
    reset: function reset() {
      this.tableFrom.auditStatus = '';
      this.tableFrom.type = '';
      this.tableFrom.title = '';
      this.tableFrom.authorName = '';
      this.tableFrom.categoryId = '';
      this.tableFrom.topicId = '';
      this.title = '';
      this.tableFrom.content = '';
      this.tableFrom.searchType = 'all';
      this.getList(1);
    },
    pageChange: function pageChange(page) {
      this.changePageCoreRecordData();
      this.tableFrom.page = page;
      this.getList('');
    },
    handleSizeChange: function handleSizeChange(val) {
      this.changePageCoreRecordData();
      this.tableFrom.limit = val;
      this.getList('');
    },
    // 编辑
    onEdit: function onEdit(row) {
      this.star = row.star;
      this.id = row.id;
      this.visible = true;
    },
    // 查看评论
    onReply: function onReply(id) {
      this.$router.push({
        path: 'reply',
        query: {
          community_id: id
        }
      });
    },
    // 审核
    onAudit: function onAudit(id, bl) {
      var _this11 = this;
      this.loadingAudit = true;
      this.currentTab = 0;
      this.getReplyNoteList(id);
      this.community_id = id;
      this.dialogVisible = true;
      this.isExamine = bl;
      community.communityNoteDetailApi(id).then(function (res) {
        _this11.formValidate = res;
        _this11.loadingAudit = false;
      });
    },
    // 强制下架
    onOff: function onOff(id) {
      var _this12 = this;
      this.$modalPrompt('textarea', '强制下架原因').then(function (V) {
        _this12.ruleForm.reason = V;
        _this12.submit(id);
      });
    },
    submit: function submit(id) {
      var _this13 = this;
      this.ruleForm.id = id;
      community.communityNoteForcedDownApi(this.ruleForm).then(function (res) {
        _this13.$message.success('下架成功');
        _this13.getList();
      });
    },
    onSubmit: function onSubmit() {
      var _this14 = this;
      community.communityAuditApi(this.community_id, this.ruleForm).then(function (res) {
        _this14.$message.success(res.message);
        _this14.dialogVisible = false;
        _this14.getList('');
      }).catch(function (res) {
        if (res && !res.__requestMessageShown) _this14.$message.error(res.message);
      });
    },
    //强制关闭评论
    onReplyOff: function onReplyOff(row) {
      var _this15 = this;
      this.$modalSure(row.replyStatus !== 3 ? '关闭评论吗？关闭之后该内容将无法评论' : '取消强制关闭评论吗？取消后评论将变成用户关闭状态').then(function () {
        community.communityNoteReplyOffApi(row.id).then(function () {
          _this15.$message.success('关闭成功');
          _this15.getList();
        });
      });
    },
    // 删除
    handleDelete: function handleDelete(id) {
      var _this16 = this;
      this.$modalSure('删除该内容吗').then(function () {
        community.communityNoteDelApi(id).then(function () {
          _this16.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this16.tableData.data.length, _this16.tableFrom);
          _this16.getList();
        });
      });
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this17 = this;
      community.communityNoteReplyOffApi(row.replyStatus).then(function () {
        _this17.getList('');
        _this17.$message.success('操作成功');
      });
    }
  }
};